"use strict";import{AlertDialog as e}from"./src/AlertDialog.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-alert-dialog",e);
//# sourceMappingURL=sp-alert-dialog.js.map
